module.exports = __webpack_public_path__ + "static/media/wq_3.a13493d7.svg";